import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const API_URL = process.env.REACT_APP_BASE_URL;

const ShopifyDataImport = () => {
  const navigate = useNavigate();
  const [parentOptions, setParentOptions] = useState([]);
  const [selectedParentNos, setSelectedParentNos] = useState([]);
  const [showParentDropdown, setShowParentDropdown] = useState(false);
  const [selectedSourceParentNo, setSelectedSourceParentNo] = useState("");
  const [showSourceDropdown, setShowSourceDropdown] = useState(false);
  const [files, setFiles] = useState([]);
  const [status, setStatus] = useState([]);
  const [importMenus, setImportMenus] = useState(false);
  const [importMetafields, setImportMetafields] = useState(false);
  const [importMetaobjects, setImportMetaobjects] = useState(false);
  const [importPages, setImportPages] = useState(false);
  const [collectionOptions, setCollectionOptions] = useState([]);
  const [selectedCollections, setSelectedCollections] = useState([]);
  const [showCollectionsDropdown, setShowCollectionsDropdown] = useState(false);
  const [loading, setLoading] = useState(false);

  // Load store parent options
  useEffect(() => {
    fetch(`${API_URL}GetShopifyStores.php`)
      .then((res) => res.json())
      .then((data) => setParentOptions(data))
      .catch((err) => {
        toast.error("Failed to load parent numbers");
        console.error(err);
      });
  }, []);

  // Close dropdowns on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".dropdown")) {
        setShowParentDropdown(false);
        setShowSourceDropdown(false);
        setShowCollectionsDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Fetch collections when Source Parent No is selected
  useEffect(() => {
    const fetchCollections = async () => {
      if (!selectedSourceParentNo) return;

      try {
        const response = await fetch(`${API_URL}GetStoreDetailsByParent.php`, {
          method: "POST",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ parentnos: [selectedSourceParentNo] }),
        });

        const storeData = await response.json();

        if (!Array.isArray(storeData) || storeData.length === 0) {
          toast.error("No store details found for source");
          setCollectionOptions([]);
          return;
        }

        const { shopify_websiteurl, access_token } = storeData[0];

        const collectionResponse = await fetch(`${API_URL}GetCollectionsFromSource.php`, {
          method: "POST",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ shopify_websiteurl, access_token })
        });

        const result = await collectionResponse.json();

        if (result.success && Array.isArray(result.collections)) {
          setCollectionOptions(result.collections);
        } else {
          toast.error("Invalid collection response");
          setCollectionOptions([]);
        }

      } catch (err) {
        console.error("Failed to fetch collections", err);
        toast.error("Error fetching collections");
        setCollectionOptions([]);
      }
    };

    fetchCollections();
  }, [selectedSourceParentNo]);

  // Handle Upload Submit
  const handleUpload = async (event) => {
    event.preventDefault();

    if (!selectedSourceParentNo) {
      toast.error("Please select Source Parent No.");
      return;
    }

    if (selectedParentNos.length === 0) {
      toast.error("Please select Target Parent No(s).");
      return;
    }


    try {
      setLoading(true);

      const response1 = await fetch(`${API_URL}GetStoreDetailsByParent.php`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ parentnos: [selectedSourceParentNo] })
      });
      const sourceStoreData = await response1.json();

      const response2 = await fetch(`${API_URL}GetStoreDetailsByParent.php`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ parentnos: selectedParentNos })
      });
      const targetStoreData = await response2.json();

      if (!Array.isArray(sourceStoreData) || sourceStoreData.length === 0) {
        toast.error("No source store found.");
        setLoading(false);
        return;
      }

      if (!Array.isArray(targetStoreData) || targetStoreData.length === 0) {
        toast.error("No target stores found.");
        setLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("images_zip", files);
      formData.append("source_store", JSON.stringify(sourceStoreData[0]));
      formData.append("store_data", JSON.stringify(targetStoreData));
      formData.append("import_menus", importMenus ? "true" : "false");
      formData.append("import_metafields", importMetafields ? "true" : "false");
      formData.append("import_metaobjects", importMetaobjects ? "true" : "false");
      formData.append("collections", JSON.stringify(selectedCollections));
      formData.append("pages", importPages ? "true" : "false");

      const response = await fetch(`${API_URL}ShopifyDataImport.php`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      setStatus(result);
      setLoading(false);

      if (response.ok) {
        toast.success("Data uploaded successfully!");
        setFiles([]);
        setSelectedParentNos([]);
        // setSelectedSourceParentNo([]);
        setImportMenus(false);
        setImportMetafields(false);
        setImportMetaobjects(false);
        setSelectedCollections([]);
        setImportPages(false);
        document.getElementById("zipFileInput").value = "";
      } else {
        toast.error("Upload failed. Please try again.");
      }
    } catch (err) {
      console.error("Upload failed:", err);
      toast.error("Error uploading Data.");
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid page-body-wrapper">
      <ToastContainer position="top-center" autoClose={500} theme="colored" />
      <div className="main-panel">
        <div className="content-wrapper" style={{ paddingBottom: "80px" }}>
          <div className="container mainbody1" style={{ maxWidth: "1900px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h2 className="form-header">Data Upload to Shopify</h2>
              <Link to="/themeupload" className="btn btn-success btn-sm">
                <i className="mdi mdi-arrow-right"></i> Theme Upload
              </Link>
            </div>

            <form onSubmit={handleUpload} style={{ padding: 30 }}>
              <div className="form-row" style={{ display: "flex", justifyContent: "space-between", gap: "20px", flexWrap: "wrap" }}>
                {/* Source Store Parent No */}
                <div className="form-group" style={{ flex: "1", minWidth: "300px", position: "relative" }}>
                  <label style={{ marginBottom: "8px" }}>
                    Source Store Parent No: <span className="requireds">*</span>
                  </label>
                  <div className="dropdown" style={{ width: "100%", position: "relative" }}>
                    <button
                      type="button"
                      className="btn"
                      onClick={() => setShowSourceDropdown(!showSourceDropdown)}
                      style={{
                        width: "100%",
                        color: "#000000",
                        textAlign: "left",
                        padding: "10px 40px 10px 12px",
                        border: "1px solid #ced4da",
                        position: "relative",
                      }}
                    >
                      {selectedSourceParentNo || "Select Source Store Parent No"}
                      <span
                        style={{
                          position: "absolute",
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                        }}
                      >
                        ▼
                      </span>
                    </button>

                    {showSourceDropdown && (
                      <div
                        className="dropdown-menu show"
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: "0",
                          width: "100%",
                          maxHeight: "200px",
                          overflowY: "auto",
                          padding: "10px",
                          zIndex: 999,
                          border: "1px solid #ced4da",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          columnGap: "20px",
                          rowGap: "10px",
                          background: "#fff",
                        }}
                      >
                        {parentOptions.map((opt) => (
                          <label
                            key={opt.parentno}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              margin: "0",
                              cursor: "pointer",
                            }}
                          >
                            <input
                              type="checkbox"
                              value={opt.parentno}
                              checked={selectedSourceParentNo === opt.parentno}
                              onChange={(e) => {
                                setSelectedSourceParentNo(e.target.checked ? opt.parentno : "");
                                setShowSourceDropdown(false);
                              }}
                              style={{ width: "16px", height: "16px" }}
                            />
                            <span>{opt.parentno}</span>
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* Target Store Parent No */}
                <div className="form-group" style={{ flex: "1", minWidth: "300px", position: "relative" }}>
                  <label style={{ marginBottom: "8px" }}>
                    Target Store Parent No: <span className="requireds">*</span>
                  </label>
                  <div className="dropdown" style={{ width: "100%", position: "relative" }}>
                    <button
                      type="button"
                      className="btn"
                      onClick={() => setShowParentDropdown(!showParentDropdown)}
                      style={{
                        width: "100%",
                        color: "#000000",
                        textAlign: "left",
                        padding: "10px 40px 10px 12px",
                        border: "1px solid #ced4da",
                        position: "relative",
                      }}
                    >
                      {selectedParentNos.length > 0 ? selectedParentNos.join(", ") : "Select Target Store Parent No"}
                      <span
                        style={{
                          position: "absolute",
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                        }}
                      >
                        ▼
                      </span>
                    </button>

                    {showParentDropdown && (
                      <div
                        className="dropdown-menu show"
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: "0",
                          width: "100%",
                          maxHeight: "200px",
                          overflowY: "auto",
                          padding: "10px",
                          zIndex: 999,
                          border: "1px solid #ced4da",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          columnGap: "20px",
                          rowGap: "10px",
                          background: "#fff",
                        }}
                      >
                        {/* Select All */}
                        <div style={{ gridColumn: "1 / -1", marginBottom: "5px" }}>
                          <label style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}>
                            <input
                              type="checkbox"
                              checked={selectedParentNos.length === parentOptions.length}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedParentNos(parentOptions.map((p) => p.parentno));
                                } else {
                                  setSelectedParentNos([]);
                                }
                              }}
                              style={{ width: "16px", height: "16px" }}
                            />
                            <strong>Select All</strong>
                          </label>
                        </div>

                        {/* Individual checkboxes */}
                        {parentOptions.map((opt) => (
                          <label
                            key={opt.parentno}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              margin: "0",
                              cursor: "pointer",
                            }}
                          >
                            <input
                              type="checkbox"
                              value={opt.parentno}
                              checked={selectedParentNos.includes(opt.parentno)}
                              onChange={(e) =>
                                setSelectedParentNos((prev) =>
                                  e.target.checked ? [...prev, opt.parentno] : prev.filter((val) => val !== opt.parentno)
                                )
                              }
                              style={{ width: "16px", height: "16px" }}
                            />
                            <span>{opt.parentno}</span>
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div><br></br>
              
              <div className="form-group">
                <div style={{ display: "flex", alignItems: "center", gap: "30px" }}>
                  
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <input
                      type="checkbox"
                      checked={importMetafields}
                      onChange={(e) => setImportMetafields(e.target.checked)}
                      style={{ width: "16px", height: "16px" }}
                    />
                    <label style={{ margin: 0 }}>Import Metafields</label>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <input
                      type="checkbox"
                      checked={importMetaobjects}
                      onChange={(e) => setImportMetaobjects(e.target.checked)}
                      style={{ width: "16px", height: "16px" }}
                    />
                    <label style={{ margin: 0 }}>Import Metaobjects</label>
                  </div>

                </div>
              </div><br></br>

              <div className="form-group">
                <label>Upload Image Zip File:</label>
                <input type="file" id="zipFileInput" onChange={(e) => setFiles(e.target.files[0])} className="form-control" accept=".zip" />
              </div><br></br>

              <div className="form-group" style={{ display: "flex", flexDirection: "column", position: "relative" }}>
                <label style={{ marginBottom: "8px" }}>
                  Collections to Import:
                </label>

                <div className="dropdown" style={{ width: "100%", position: "relative" }}>
                  <button
                    type="button"
                    className="btn"
                    onClick={() => {
                      if (selectedSourceParentNo) {
                        setShowCollectionsDropdown(!showCollectionsDropdown);
                      }
                    }}
                    disabled={!selectedSourceParentNo}
                    title={
                      !selectedSourceParentNo
                        ? "Please Select a Source Store to View Collections"
                        : ""
                    }
                    style={{
                      width: "100%",
                      color: "#000000",
                      textAlign: "left",
                      padding: "10px 40px 10px 12px",
                      border: "1px solid #ced4da",
                      position: "relative",
                      backgroundColor: !selectedSourceParentNo ? "#f8f9fa" : "#fff",
                      cursor: !selectedSourceParentNo ? "not-allowed" : "pointer"
                    }}
                  >
                    {selectedCollections.length > 0
                      ? selectedCollections.map((c) => c.title).join(", ")
                      : "Select Collections to Import"}
                    <span
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                      }}
                    >
                      ▼
                    </span>
                  </button>
                  {showCollectionsDropdown && (
                    <div
                      className="dropdown-menu show"
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: "0",
                        width: "100%",
                        maxHeight: "150px",
                        marginBottom: "10px",
                        overflowY: "auto",
                        padding: "10px",
                        zIndex: 999,
                        border: "1px solid #ced4da",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        columnGap: "20px",
                        rowGap: "10px",
                        background: "#fff",
                      }}
                    >
                      {collectionOptions.length === 0 ? (
                        <div style={{ gridColumn: "1 / -1", color: "#888", fontStyle: "italic" }}>
                          {selectedSourceParentNo
                            ? "No collections found for selected source."
                            : "No Source Store No selected to load collections"}
                        </div>
                      ) : (
                        <>
                          {/* Select All Option */}
                          <div style={{ gridColumn: "1 / -1", marginBottom: "5px" }}>
                            <label style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}>
                              <input
                                type="checkbox"
                                checked={selectedCollections.length === collectionOptions.length}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedCollections([...collectionOptions]);
                                  } else {
                                    setSelectedCollections([]);
                                  }
                                }}
                                style={{ width: "16px", height: "16px" }}
                              />
                              <strong>Select All</strong>
                            </label>
                          </div>

                          {/* Individual Collection Options */}
                          {collectionOptions.map((col) => (
                            <label
                              key={col.id}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                margin: "0",
                                cursor: "pointer",
                              }}
                            >
                              <input
                                type="checkbox"
                                value={col.id}
                                checked={selectedCollections.some((c) => c.id === col.id)}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedCollections((prev) => [...prev, col]);
                                  } else {
                                    setSelectedCollections((prev) => prev.filter((c) => c.id !== col.id));
                                  }
                                }}
                                style={{ width: "16px", height: "16px" }}
                              />
                              <span>{col.title}</span>
                            </label>
                          ))}
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div><br></br>


              <div className="form-group">
                <div style={{ display: "flex", alignItems: "center", gap: "30px" }}>
                  
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <input
                      type="checkbox"
                      checked={importMenus}
                      onChange={(e) => setImportMenus(e.target.checked)}
                      style={{ width: "16px", height: "16px" }}
                    />
                    <label style={{ margin: 0 }}>Import Menus</label>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <input
                      type="checkbox"
                      checked={importPages}
                      onChange={(e) => setImportPages(e.target.checked)}
                      style={{ width: "16px", height: "16px" }}
                    />
                    <label style={{ margin: 0 }}>Import Pages</label>
                  </div>

                </div>
              </div><br></br>
              <center>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? "Uploading..." : "Upload"}
                </button>
              </center>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopifyDataImport;
